// extracted by mini-css-extract-plugin
export default {"cropControls":"CropControls_cropControls__JPbof"};